import { PropsWithChildren } from 'react'

import { Drawer, Space } from 'antd'

import { DraggableModal } from '@eastcoal/common/components/DraggableModal'
import { pick } from '@eastcoal/common/utils/object'

import { CrudFormStoreProvider } from '../../CrudForm/Store'
import { useCrudModalFormStore } from '../Store/hooks/useStore'

import { CrudModalFormContainerProps } from './interface'

export const CrudModalFormContainer = ({
  /* -------------------------------------------------------------------------- */
  /*                      CrudFormStoreProvider Props                           */
  /* -------------------------------------------------------------------------- */
  mode,
  detailType,
  context,
  form,
  initialValues,
  values,
  mergeStrategy,
  createApi,
  updateApi,
  readApi,
  onSuccess,
  onModeChange,
  effects,
  validateFirst,
  /* -------------------------------------------------------------------------- */
  /*                                 Common Props                                */
  /* -------------------------------------------------------------------------- */
  type = 'modal',
  mask,
  destroyOnHidden = true,
  size: externalSize,
  title,
  actions,
  ...restProps
}: PropsWithChildren<CrudModalFormContainerProps>) => {
  const { open, toggleModalOpen } = useCrudModalFormStore(state =>
    pick(state, ['open', 'toggleModalOpen'])
  )

  if (destroyOnHidden && !open) {
    return null
  }

  const mergedMask = Object.assign(
    {
      closable: true
    },
    mask
  )

  const containerNode =
    type === 'modal' ? (
      <DraggableModal
        keyboard
        footer={actions}
        mask={mergedMask}
        open={open}
        title={title}
        width={externalSize}
        onOpenChange={toggleModalOpen}
        {...restProps}
      />
    ) : (
      <Drawer
        keyboard
        extra={<Space size='middle'>{actions}</Space>}
        mask={mergedMask}
        open={open}
        size={externalSize}
        title={title}
        onClose={toggleModalOpen}
        {...restProps}
      />
    )

  return (
    <CrudFormStoreProvider
      createApi={createApi}
      detailType={detailType}
      effects={effects}
      form={form}
      initialValues={initialValues}
      mergeStrategy={mergeStrategy}
      mode={mode}
      readApi={readApi}
      updateApi={updateApi}
      validateFirst={validateFirst}
      values={values}
      context={{
        ...context,
        modalOpen: open
      }}
      onModeChange={onModeChange}
      onSuccess={onSuccess}
    >
      {containerNode}
    </CrudFormStoreProvider>
  )
}
